import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CargueArchivosTramiteService {
  private apiUrl = `${environment.apiUrl}/cargue-archivos-tramite`;
  private apiUrlPublico = `${environment.apiUrl}/`;

  constructor(private http: HttpClient) { }

  // BehaviorSubject para almacenar el tipo de reclamación seleccionado en la sección de reclamo directo
  private dataSource = new BehaviorSubject<any>(null);
  data$ = this.dataSource.asObservable();

  setData(data: any) {
    this.dataSource.next(data);
  }

  // BehaviorSubject para recargar el componente de documentos
  private _recargar = new BehaviorSubject<boolean>(false);
  recargar$ = this._recargar.asObservable();

  emitirRecarga() {
    this._recargar.next(true);
  }

  getTipoArchivosTramite(idTipoTramite: number, codigoPretencion?: string) {
    const params: any = {};

    if (codigoPretencion) {
      params['codigo-pretencion'] = codigoPretencion;
    }
    return this.http
      .get(
        `${this.apiUrl}/obtener-tipos-anexo-por-tipo-tramite/${idTipoTramite}`,
        { params }
      )
      .pipe();
  }

  getTipoArchivosTramitePasos(idTipoTramite: number, paso?: number, codigoPretencion?: string, solicitante?: string) {
    const params: any = {};
    if (paso) {
      params['paso'] = paso;
    }
    if (codigoPretencion) {
      params['codigo-pretension'] = codigoPretencion;
    }
    if (solicitante) {
      params['solicitante'] = solicitante;
    }

    return this.http
      .get(
        `${this.apiUrl}/obtener-tipos-anexo-por-tipo-tramite-paso/${idTipoTramite}`,
        { params }
      )
      .pipe();
  }

  getTipoArchivosEmpresaPublico() {
    const params: any = {};

    return this.http
      .get(
        `${this.apiUrlPublico}anexo-registro-empresa/obtener-tipos-anexo`,
        { params }
      )
      .pipe();
  }


  guardarArchivos(
    idTramite: number,
    idTipoAnexoTipoTramite: number,
    data: FormData
  ): Observable<{ status: number; mensaje: string }> {
    data.forEach((value, key) => {

    });
    return this.http
      .post<{
        status: number;
        mensaje: string;
      }>(`${this.apiUrl}/${idTramite}/${idTipoAnexoTipoTramite}`, data)
      .pipe();
  }

  eliminarArchivos(
    idTramite: number,
    idTipoAnexo: number,
    nombre: string
  ): Observable<{ status: number; mensaje: string }> {
    return this.http
      .get<{
        status: number;
        mensaje: string;
      }>(`${this.apiUrl}/eliminar/${idTramite}/${idTipoAnexo}/${nombre}`)
      .pipe();
  }
}
